<template>
	<formio-builder-component
		class="formio-builder-component"
		:formExpansionDefinition=formDefinition
		:createNew=createNew
		:baseOptions=baseOptions
		@close=closeFormioBuilder
	/>
</template>
<script>
import { installFormio } from '../../formio'

export default {
  props: ['formDefinition', 'createNew'],
  data() {
    return {
      baseOptions: {
        noDefaultSubmitButton: true
      }
    }
  },
  methods: {
    closeFormioBuilder(params) {
      if (this.createNew) {
        this.$store.state['processes'].formCode = params.formExpansionDefinition.formCode
      }
      this.changeFormVisible(false)
    },
    changeFormVisible(visible) {
      this.$emit('changeFormVisible', visible)
    }
  },
  async created () {
    await installFormio()
  }
}
</script>
<style>

</style>